import React from "react"
import { makeStyles } from "@material-ui/styles"
import { Box, Hidden } from "@material-ui/core"
import { NavLink } from "react-router-dom"
import { ActionCard } from "./ActionCard"
import { useProcessUtils, toId, useDateUtils, useStringUtils } from "../../utils"
import { AuthorTools } from "../Author"
import { RowBox } from "../Boxes"
import { AdornmentIcon } from "../Icon"
import { FormatDateCompact, FormatTime } from "../Format"
import { ActionCardInfo } from "./ActionCardInfo"
import { Tooltip } from "../Tooltip"

const useStyles = makeStyles((theme) => ({
  info: {
    fontSize: 14,
    color: theme.palette.text.light,
    marginBottom: theme.spacing(1),
  },
  rightChildren: {
    height: 40,
    overflow: "visible",
  },
  locations: {
    fontWeight: "600",
    color: theme.palette.primary.main,
  },
  location: {
    fontWeight: "500",
  },
}))

const TaskTemplateActionCard = ({
  task,
  set,
  onEdit,
  // onCopy,
  onDisable,
  // onDelete
}) => {
  const { name, inactive, locations } = task
  const classes = useStyles()
  const { getNavigateToLink } = useProcessUtils()
  const { formatTime, hasScheduleDate, scheduleDateToMoment } = useDateUtils()
  const { truncateInMiddle } = useStringUtils()

  const handleEdit = () => {
    if (onEdit) onEdit(task)
  }
  // const handleCopy = () => {
  //   if (onCopy) onEdit(onCopy)
  // }
  const handleDisable = () => {
    if (onDisable) onDisable(task)
  }
  // const handleDelete = () => {
  //   if (onDelete) onDelete(task)
  // }

  const statusPrefix = inactive ? "Inactive for" : `Active ${locations?.length > 1 ? "in" : "for"}`

  return (
    <ActionCard
      title={name}
      cardProps={{ component: NavLink, to: { pathname: getNavigateToLink(task, set, "view") } }}
      rightChildren={
        !inactive && (
          <Box
            mr="auto"
            display="flex"
            flexDirection="row"
            alignSelf="center"
            alignItems="center"
            className={classes.rightChildren}
          >
            <AuthorTools
              item={task}
              author={toId(task.author)}
              subject="task"
              admins={{ edit: "task_update_all", delete: "task_delete_all" }}
              disableLabel={inactive ? "Make active" : "Make inactive"}
              onEdit={handleEdit}
              onDisable={handleDisable}
            />
          </Box>
        )
      }
      footer={
        <>
          <Box alignItems="center" display="flex" flexDirection="row">
            <Hidden smUp>
              <ActionCardInfo>
                <AdornmentIcon
                  name="date"
                  tooltip={
                    <>
                      Start: <FormatDateCompact value={scheduleDateToMoment(task.after)} />
                    </>
                  }
                />
              </ActionCardInfo>
            </Hidden>
            <Hidden xsDown>
              <AdornmentIcon name="date" tooltip="Start" />
              <Box ml={1} mr={5}>
                <FormatDateCompact value={scheduleDateToMoment(task.after)} />
              </Box>
            </Hidden>

            {hasScheduleDate(task.due) && (
              <>
                <Hidden smUp>
                  <AdornmentIcon name="due" tooltip={<>Due: {formatTime(scheduleDateToMoment(task.due))}</>} />
                </Hidden>
                <Hidden xsDown>
                  <AdornmentIcon name="due" tooltip="Due" />
                  <Box ml={1} mr={5}>
                    <FormatTime value={scheduleDateToMoment(task.due)} />
                  </Box>
                </Hidden>
              </>
            )}

            {task.pinned && (
              <>
                <Hidden smUp>
                  <ActionCardInfo>
                    <AdornmentIcon name="pinned" tooltip="Until completed" />
                  </ActionCardInfo>
                </Hidden>
                <Hidden xsDown>
                  <AdornmentIcon name="pinned" />
                  <Box ml={1} mr={5}>
                    Until completed
                  </Box>
                </Hidden>
              </>
            )}
          </Box>
          <RowBox ml="auto">
            {Boolean(locations.length) && (
              <Box display="flex" alignItems="center" flexDirection="row">
                <Box mr={0.5}>{statusPrefix}</Box>
                {locations.length === 1 && (
                  <Box className={classes.location}>{truncateInMiddle(locations[0].name, 25)}</Box>
                )}
                {locations.length > 1 && (
                  <Tooltip title={locations.map((location) => location.name).join(", ")}>
                    <Box className={classes.locations}>
                      {locations.length} location{locations.length > 1 ? "s" : ""}
                    </Box>
                  </Tooltip>
                )}
              </Box>
            )}
            {!locations.length && <Box>{statusPrefix} 0 locations</Box>}
          </RowBox>
        </>
      }
    />
  )
}

export { TaskTemplateActionCard }
